import { User } from 'oidc-client';
import { CallbackComponent } from 'redux-oidc';
import userManager from '../../settings/oAuthSettings';


const CallbackPage = () => {
    console.log('Chat CallBackPage');
    const successCallback = (user: User) => {
        console.log('successCallback', user);
        window.location.href = user.state ? user.state : "./";
        //window.location.href = "./";
    };

    const errorCallback = (error: Error) => {
        console.error('errorCallback', error);
        //try re-authenticate
        //authManager.signinRedirect();
    };


    console.log('CallbackPage authManager', userManager);
    return (
        <CallbackComponent userManager={userManager} successCallback={successCallback} errorCallback={errorCallback} >
            <></>
        </CallbackComponent>
    )
}

export default CallbackPage;